import { OETrans } from '@components/translation/OETrans';
import { IcoCheckmarkSolid, IcoSpinner } from '@icons';
import { sendReportingDocuments } from '@lib/api_ts/continuosReportingApi';
import { useCallback, useState } from 'react';
import { Modal } from 'react-bootstrap';
import UploadDownloadButton from './UploadDownloadButton';

const MassiveReportingDownload = ({ projectId, statementId, disabled }: { projectId: string; statementId: number; disabled?: boolean }) => {
	const [showModal, setShowModal] = useState(false);
	const [loading, setLoading] = useState(false);

	const onClick = useCallback(async () => {
		setLoading(true);
		setShowModal(true);
		try {
			await sendReportingDocuments(projectId, statementId);
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	}, [projectId, statementId, setShowModal, setLoading]);

	return (
		<>
			<UploadDownloadButton onClick={onClick} variant="download" disabled={disabled}>
				Scarica documenti
			</UploadDownloadButton>
			<Modal show={showModal} size="lg" onHide={() => setShowModal(false)} style={{ zIndex: 9999 }} centered>
				<Modal.Header closeButton>
					<Modal.Title>Scarica documenti</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							gap: '18px',
							margin: '64px 0px',
						}}
					>
						{loading ? <IcoSpinner className="spin" /> : <IcoCheckmarkSolid />}
						<span>
							{' '}
							{loading ? (
								<OETrans code="massivereportingdownload.loading" fallback="La generazione del file .zip è in corso" />
							) : (
								<OETrans code="massivereportingdownload.done" fallback="La generazione del file .zip è stata completata" />
							)}
						</span>
						{!loading && (
							<span style={{ color: '#08A2AA', fontWeight: 700 }}>
								<OETrans code="massivereportingdownload.emailsent" fallback={'È stata inviata una e-mail con il link per il download'} />
							</span>
						)}
					</div>
					{/* DA RIABILITARE QUANDO VIENE INVIATA UNA NOTIFICA INSIEME ALL'EMAIL */}
					{/* {loading && (
						<Modal.Footer style={{ textAlign: 'center' }}>
							<OETrans
								code="massivereportingdownload.close"
								fallback={
									'Puoi chiudere questa finestra, la generazione continuerà in background, riceverai una notifica quando il file sarà pronto'
								}
							/>
						</Modal.Footer>
					)} */}
				</Modal.Body>
			</Modal>
		</>
	);
};

export default MassiveReportingDownload;
